import React, { useState } from "react";

export const CONSENT_TRANSLATIONS = {
  en: {
    heading: "I hereby declare that:",
    acceptAll: "Accept All",
    consent1:
      "I consent to the anonymization and subsequent use of my government health records for public health purposes.",
    consent2Prefix: "I, ",
    consent2Suffix:
      " confirm that I have duly informed and explained the beneficiary of the contents of consent for aforementioned purposes.",
    consent3Prefix: "I, ",
    consent3Placeholder: "beneficiary name",
    consent3Suffix:
      ", have been explained about the consent as stated above and hereby provide my consent for the aforementioned purposes.",
    consent4:
      'I am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India ("UIDAI"), and my demographic information for the purpose of creating an Ayushman Bharat Health Account number ("ABHA number") and Ayushman Bharat Health Account address ("ABHA Address"). I authorize NHA to use my Aadhaar number / Virtual ID for performing Aadhaar based authentication with UIDAI as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI will share my e-KYC details, or response of "Yes" with NHA upon successful authentication.',
    consent5:
      'I intend to create Ayushman Bharat Health Account Number ("ABHA number") and Ayushman Bharat Health Account address ("ABHA Address") using document other than Aadhaar. (Click here to proceed further)',
    consent6:
      "I consent to usage of my ABHA address and ABHA number for linking of my legacy (past) government health records and those which will be generated during this encounter.",
    consent7:
      "I authorize the sharing of all my health records with healthcare provider(s) for the purpose of providing healthcare services to me during this encounter.",
  },
  hi: {
    heading: "मैं एतद्द्वारा घोषणा करता/करती हूँ कि:",
    acceptAll: "सभी स्वीकार करें",
    consent1:
      "मैं सार्वजनिक स्वास्थ्य उद्देश्यों के लिए अपने सरकारी स्वास्थ्य रिकॉर्ड के अनामीकरण (anonymization) और बाद में उपयोग के लिए सहमति देता/देती हूँ।",
    consent2Prefix: "मैं, ",
    consent2Suffix:
      " पुष्टि करता/करती हूँ कि मैंने पूर्वोक्त प्रयोजनों के लिए सहमति की सामग्री के बारे में लाभार्थी को विधिवत सूचित और स्पष्ट कर दिया है।",
    consent3Prefix: "मैं, ",
    consent3Placeholder: "लाभार्थी का नाम",
    consent3Suffix:
      ", ऊपर बताए अनुसार सहमति के बारे में समझ गया/गई हूँ और एतद्द्वारा पूर्वोक्त प्रयोजनों के लिए अपनी सहमति प्रदान करता/करती हूँ।",
    consent4:
      'मैं स्वेच्छा से आयुष्मान भारत स्वास्थ्य खाता संख्या ("आभा संख्या") और आयुष्मान भारत स्वास्थ्य खाता पता ("आभा पता") बनाने के उद्देश्य से भारतीय विशिष्ट पहचान प्राधिकरण ("UIDAI") द्वारा जारी अपना आधार नंबर / वर्चुअल आईडी और अपनी जनसांख्यिकीय जानकारी साझा कर रहा/रही हूँ। मैं उक्त उद्देश्य के लिए आधार (वित्तीय और अन्य सब्सिडी, लाभ और सेवाओं का लक्षित वितरण) अधिनियम, 2016 के प्रावधानों के अनुसार यूआईडीएआई (UIDAI) के साथ आधार आधारित प्रमाणीकरण करने के लिए एनएचए (NHA) को अपने आधार नंबर / वर्चुअल आईडी का उपयोग करने के लिए अधिकृत करता/करती हूँ। मैं समझता/समझती हूँ कि सफल प्रमाणीकरण पर यूआईडीएआई (UIDAI) मेरे ई-केवाईसी विवरण या "हाँ" की प्रतिक्रिया एनएचए (NHA) के साथ साझा करेगा।',
    consent5:
      'मैं आधार के अलावा अन्य दस्तावेज का उपयोग करके आयुष्मान भारत स्वास्थ्य खाता संख्या ("आभा संख्या") और आयुष्मान भारत स्वास्थ्य खाता पता ("आभा पता") बनाने का इरादा रखता/रखती हूँ। (आगे बढ़ने के लिए यहाँ क्लिक करें)',
    consent6:
      "मैं अपने पुराने (पिछले) सरकारी स्वास्थ्य रिकॉर्ड और इस मुलाकात के दौरान उत्पन्न होने वाले रिकॉर्ड को लिंक करने के लिए अपने आभा पते और आभा संख्या के उपयोग के लिए सहमति देता/देती हूँ।",
    consent7:
      "मैं इस मुलाकात के दौरान मुझे स्वास्थ्य सेवाएं प्रदान करने के उद्देश्य से स्वास्थ्य सेवा प्रदाता (प्रदाताओं) के साथ अपने सभी स्वास्थ्य रिकॉर्ड साझा करने के लिए अधिकृत करता/करती हूँ।",
  },
};

const AadharConsentSection = ({
  acceptAll,
  handleAcceptAll,
  consent1,
  setConsent1,
  consent2,
  setConsent2,
  consent3,
  setConsent3,
  consent4,
  setConsent4,
  consent5,
  setConsent5,
  consent6,
  setConsent6,
  consent7,
  setConsent7,
  beneficiaryName,
  setBeneficiaryName,
  healthcareWorkerName,
  language: controlledLanguage,
  onLanguageChange,
}) => {
  const [internalLanguage, setInternalLanguage] = useState("en");
  const language = controlledLanguage || internalLanguage;

  const setLanguage = (lang) => {
    setInternalLanguage(lang);
    if (onLanguageChange) {
      onLanguageChange(lang);
    }
  };

  const t = CONSENT_TRANSLATIONS[language] || CONSENT_TRANSLATIONS.en;

  return (
    <>
      <h6
        style={{
          margin: "0 0 10px 0",
          fontSize: "14px",
          fontWeight: "600",
        }}
      >
        {t.heading}
      </h6>

      {/* Accept All Checkbox and English / Hindi language buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            id="acceptAll"
            checked={acceptAll}
            onChange={(e) => handleAcceptAll(e.target.checked)}
            style={{
              marginRight: "8px",
              cursor: "pointer",
            }}
          />
          <label
            htmlFor="acceptAll"
            style={{
              fontSize: "13px",
              margin: 0,
              cursor: "pointer",
              fontWeight: "600",
              color: "#1976d2",
            }}
          >
            {t.acceptAll}
          </label>
        </div>

        {/* English & Hindi Language Switcher */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: "#e8edf2",
            borderRadius: "20px",
            padding: "2px",
            border: "1px solid #cbd5e1",
          }}
        >
          <button
            type="button"
            onClick={() => setLanguage("en")}
            style={{
              padding: "3px 12px",
              fontSize: "12px",
              fontWeight: language === "en" ? "600" : "500",
              color: language === "en" ? "#ffffff" : "#475569",
              backgroundColor: language === "en" ? "#1976d2" : "transparent",
              borderRadius: "16px",
              border: "none",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              boxShadow:
                language === "en" ? "0 1px 3px rgba(0,0,0,0.15)" : "none",
            }}
          >
            English
          </button>
          <button
            type="button"
            onClick={() => setLanguage("hi")}
            style={{
              padding: "3px 12px",
              fontSize: "12px",
              fontWeight: language === "hi" ? "600" : "500",
              color: language === "hi" ? "#ffffff" : "#475569",
              backgroundColor: language === "hi" ? "#1976d2" : "transparent",
              borderRadius: "16px",
              border: "none",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              boxShadow:
                language === "hi" ? "0 1px 3px rgba(0,0,0,0.15)" : "none",
            }}
          >
            हिंदी
          </button>
        </div>
      </div>

      {/* Scrollable consent container */}
      <div
        style={{
          maxHeight: "200px",
          overflowY: "auto",
          paddingRight: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          padding: "10px",
          backgroundColor: "#fff",
        }}
      >
        {/* Consent 1 - Public Health Purposes */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "10px",
          }}
        >
          <input
            type="checkbox"
            id="consent1"
            checked={consent1}
            onChange={(e) => setConsent1(e.target.checked)}
            style={{
              marginRight: "10px",
              marginTop: "3px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <label
            htmlFor="consent1"
            style={{
              fontSize: "12px",
              margin: 0,
              cursor: "pointer",
              lineHeight: "1.5",
            }}
          >
            {t.consent1}
          </label>
        </div>

        {/* Consent 2 - Healthcare Worker Confirmation */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "10px",
          }}
        >
          <input
            type="checkbox"
            id="consent2"
            checked={consent2}
            onChange={(e) => setConsent2(e.target.checked)}
            style={{
              marginRight: "10px",
              marginTop: "3px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <label
            htmlFor="consent2"
            style={{
              fontSize: "12px",
              margin: 0,
              cursor: "pointer",
              lineHeight: "1.5",
            }}
          >
            {t.consent2Prefix}
            {healthcareWorkerName}
            {t.consent2Suffix}
          </label>
        </div>

        {/* Consent 3 - Beneficiary Confirmation with Input */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "10px",
          }}
        >
          <input
            type="checkbox"
            id="consent3"
            checked={consent3}
            onChange={(e) => setConsent3(e.target.checked)}
            style={{
              marginRight: "10px",
              marginTop: "3px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <label
            htmlFor="consent3"
            style={{
              fontSize: "12px",
              margin: 0,
              cursor: "pointer",
              lineHeight: "1.5",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flexWrap: "wrap",
            }}
          >
            {t.consent3Prefix}
            <input
              type="text"
              value={beneficiaryName}
              onChange={(e) => setBeneficiaryName(e.target.value)}
              placeholder={t.consent3Placeholder}
              style={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "2px 6px",
                fontSize: "12px",
                minWidth: "120px",
                maxWidth: "200px",
              }}
            />
            {t.consent3Suffix}
          </label>
        </div>

        {/* Consent 4 - Main Aadhaar Declaration */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "10px",
          }}
        >
          <input
            type="checkbox"
            id="consent4"
            checked={consent4}
            onChange={(e) => setConsent4(e.target.checked)}
            style={{
              marginRight: "10px",
              marginTop: "3px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <label
            htmlFor="consent4"
            style={{
              fontSize: "12px",
              margin: 0,
              cursor: "pointer",
              lineHeight: "1.5",
            }}
          >
            {t.consent4}
          </label>
        </div>

        {/* Consent 5 - Document Other than Aadhaar */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "10px",
          }}
        >
          <input
            type="checkbox"
            id="consent5"
            checked={consent5}
            onChange={(e) => setConsent5(e.target.checked)}
            style={{
              marginRight: "10px",
              marginTop: "3px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <label
            htmlFor="consent5"
            style={{
              fontSize: "12px",
              margin: 0,
              cursor: "pointer",
              lineHeight: "1.5",
            }}
          >
            {t.consent5}
          </label>
        </div>

        {/* Consent 6 - Linking Legacy Records */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "10px",
          }}
        >
          <input
            type="checkbox"
            id="consent6"
            checked={consent6}
            onChange={(e) => setConsent6(e.target.checked)}
            style={{
              marginRight: "10px",
              marginTop: "3px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <label
            htmlFor="consent6"
            style={{
              fontSize: "12px",
              margin: 0,
              cursor: "pointer",
              lineHeight: "1.5",
            }}
          >
            {t.consent6}
          </label>
        </div>

        {/* Consent 7 - Healthcare Provider Sharing */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "10px",
          }}
        >
          <input
            type="checkbox"
            id="consent7"
            checked={consent7}
            onChange={(e) => setConsent7(e.target.checked)}
            style={{
              marginRight: "10px",
              marginTop: "3px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          />
          <label
            htmlFor="consent7"
            style={{
              fontSize: "12px",
              margin: 0,
              cursor: "pointer",
              lineHeight: "1.5",
            }}
          >
            {t.consent7}
          </label>
        </div>
      </div>
    </>
  );
};

export default AadharConsentSection;
